$(function() {

    function setAccordionBehavior() {
        if (window.innerWidth < 768) {
            // すでにバインドされていたら解除してから再バインド（重複防止）
            $(".unit dt").off("click.accordion").on("click.accordion", function () {
            $(this).next("dd").slideToggle();
            $(this).toggleClass("active");
            });
        } else {
            // 768px未満ではイベントを解除
            $(".unit dt").off("click.accordion");
        }
        }

        // 初期化時に実行
        $(window).on("load resize", function () {
        setAccordionBehavior();
        });
        
        });